import React, { useCallback, useImperativeHandle, useState } from 'react'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import AddFeeScheduleForm from './form'

const AddFeeScheduleDialog = React.forwardRef(function AddFeeScheduleDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (client) => setDialogState({ open: true, processing: false, client })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Fee Schedule'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<AddFeeScheduleForm client={dialogState.client} onComplete={close} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

AddFeeScheduleDialog.propTypes = {
}

export default AddFeeScheduleDialog
